import React, { useState, useEffect } from 'react'
import BusinessDashboard from './BusinessDashboard';
import BusinessMenu from './BusinessMenu';
import BusinessDeals from './BusinessDeals';
import ReviewSection from './ReviewSection';
import PhotosSections from './PhotosSections';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { getData } from '../helpers/api';
import { IMAGE_URL } from '../Constants/constants';
import BpChat from './BpChat';
import VibirrPosts from './VibirrPosts';

const TABS = [
	{ id: 'menu', label: 'Products', icon: 'fa-cube' },
	{ id: 'deals', label: 'Deals', icon: 'fa-tag' },
	{ id: 'reviews', label: 'Reviews', icon: 'fa-star-o' },
	{ id: 'photos', label: 'Photos', icon: 'fa-picture-o' },
	{ id: 'vibirr', label: 'ViBirr', icon: 'fa-rss' },
	{ id: 'dashboard', label: 'About', icon: 'fa-info-circle' },
];

export default function BusinessPageNew() {
	const token = localStorage.getItem('token');
	const [compCard, setCompCard] = useState('menu');
	const [bizId, setBizId] = useState('');
	const [sellerData, setSellerData] = useState({});
	const [follow, setFollow] = useState(true);
	const [chatOpen, setChatOpen] = useState(false);
	const [loadFailed, setLoadFailed] = useState(false);
	const [vbProfile, setVbProfile] = useState(null);
	const location = useLocation();

	useEffect(() => {
		const path = location.pathname.split('/')[2];
		setBizId(path);
		getBizDetails(path);
		getFollowers(path);
		window.scrollTo(0, 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	const getBizDetails = (path, attempt = 0) => {
		setLoadFailed(false);
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/seller/${path}`, {
			headers: { 'Authorization': 'Bearer ' + token },
			timeout: 15000,
		}).then(response => {
			if (response.data.status) {
				const sd = response.data.sellers[0] || {};
				setSellerData(sd);
				if (sd.walletAddress) {
					axios.get(`${process.env.REACT_APP_APP_API_URL}/api/vibirr/profile/${sd.walletAddress}`)
						.then(r => { if (r.data.status) setVbProfile(r.data.profile && (r.data.profile.profile || r.data.profile)); })
						.catch(() => {});
				}
			}
		}).catch(() => {
			// the API machine may be waking — retry once, then show recovery UI
			if (attempt < 1) return getBizDetails(path, attempt + 1);
			setLoadFailed(true);
		})
	}

	const getFollowers = (path) => {
		if (!token) return;
		getData(`${process.env.REACT_APP_APP_API_URL}/api/follow`).then(res => {
			if (res.data.status) {
				res.data.following.forEach(d => {
					if (d.following && d.following._id === path) setFollow(false);
				});
			}
		}).catch(() => {})
	}

	const followerHandler = () => {
		if (!token) { toast.info('Log in to follow shops'); return; }
		axios.post(`${process.env.REACT_APP_APP_API_URL}/api/follow`, { seller: bizId }, {
			headers: { 'Authorization': 'Bearer ' + token },
		}).then(response => {
			if (response.data.status) { setFollow(false); toast.success('Following ' + (sellerData.businessName || 'shop')); }
		}).catch(() => {})
	}

	const unfollow = () => {
		axios.post(`${process.env.REACT_APP_APP_API_URL}/api/unfollow`, { seller: bizId }, {
			headers: { 'Authorization': 'Bearer ' + token },
		}).then(response => {
			if (response.data.status) { setFollow(true); toast.success('Unfollowed'); }
		}).catch(() => {})
	}

	const reviewCount = sellerData.reviews ? sellerData.reviews.length : 0;
	const productCount = sellerData.products ? sellerData.products.length : 0;
	const cover = (sellerData.promoImage && sellerData.promoImage[0])
		? IMAGE_URL + sellerData.promoImage[0]
		: (sellerData.coverImage ? IMAGE_URL + sellerData.coverImage : null);

	if (loadFailed && !sellerData._id) {
		return (
			<div className="bp-biz-page">
				<div className="bp-results-empty" style={{ marginTop: 60 }}>
					<h3>Couldn't load this shop</h3>
					<p className="bp-dim">The connection timed out — it usually works on a retry.</p>
					<button className="bp-btn-primary" style={{ marginTop: 14 }} onClick={() => getBizDetails(bizId)}>Try Again</button>
				</div>
			</div>
		);
	}

	return (
		<div className="bp-biz-page">
			{/* hero */}
			<div className="bp-biz-hero">
				<div className="bp-biz-cover">
					{cover
						? <img src={cover} alt="" />
						: <div className="bp-biz-cover-fallback" aria-hidden="true" />}
				</div>
				<div className="bp-biz-head">
					<div className="bp-biz-id">
						<div className="bp-biz-avatar">
							<img alt="" src={sellerData.image ? IMAGE_URL + sellerData.image : "/images/placeholder.svg"} />
						</div>
						<div className="bp-biz-meta">
							<h1>{sellerData.businessName || '…'}</h1>
							<div className="bp-biz-chips">
								{sellerData.businessType && <span className="bp-shop-chip">{sellerData.businessType}</span>}
								{(sellerData.city || sellerData.state) && (
									<span className="bp-biz-chip">📍 {sellerData.city}{sellerData.city && sellerData.state ? ', ' : ''}{sellerData.state}</span>
								)}
								{sellerData.ownerPhone && <span className="bp-biz-chip">📞 {sellerData.ownerPhone}</span>}
								<span className="bp-biz-chip">⭐ {reviewCount} review{reviewCount === 1 ? '' : 's'}</span>
								<span className="bp-biz-chip">📦 {productCount} product{productCount === 1 ? '' : 's'}</span>
								{vbProfile && Number(vbProfile.birrconnect_followers) > 0 && (
									<span className="bp-biz-chip bp-biz-chip-vb"><em className="bp-chat-vb">ViBirr</em> {vbProfile.birrconnect_followers} follower{Number(vbProfile.birrconnect_followers) === 1 ? '' : 's'}</span>
								)}
							</div>
						</div>
					</div>
					<div className="bp-biz-actions">
						{follow
							? <button className="bp-btn-primary" onClick={followerHandler}>♥ Follow</button>
							: <button className="bp-btn-ghost" onClick={unfollow}>✓ Following</button>}
						<button
							className="bp-btn-ghost"
							onClick={() => {
								if (!token) { toast.info('Log in to message shops'); return; }
								if (!sellerData.walletAddress) { toast.info("This shop hasn't linked a wallet for messaging yet"); return; }
								setChatOpen(true);
							}}>
							💬 Message
						</button>
					</div>
				</div>
			</div>

			{/* tabs */}
			<nav className="bp-profile-tabs bp-biz-tabs" aria-label="Shop sections">
				{TABS.map(t => (
					<button
						key={t.id}
						className={`bp-profile-tab ${compCard === t.id ? 'active' : ''}`}
						onClick={() => setCompCard(t.id)}>
						<i className={`fa ${t.icon}`} /> {t.label}
					</button>
				))}
			</nav>

			<div className="bp-biz-body">
				{compCard === 'menu' && <BusinessMenu seller={sellerData} />}
				{compCard === 'dashboard' && <BusinessDashboard seller={sellerData} />}
				{compCard === 'deals' && <BusinessDeals seller={sellerData} />}
				{compCard === 'reviews' && <ReviewSection seller={sellerData} bizId={bizId} />}
				{compCard === 'photos' && <PhotosSections seller={sellerData} />}
				{compCard === 'vibirr' && <VibirrPosts wallet={sellerData.walletAddress} businessName={sellerData.businessName} />}
			</div>

			{chatOpen && (
				<BpChat
					open={chatOpen}
					onClose={() => setChatOpen(false)}
					recipient={{ address: sellerData.walletAddress, name: sellerData.businessName }}
				/>
			)}
		</div>
	)
}
